import { CheckCircle2 } from "lucide-react";
import { Reveal } from "./Motion";
import { WhatsAppIcon } from "./Brand";
import { waLink } from "../lib/site";

const IMG = "/img/real/equipment";
export const EQUIPMENT = [
  { id: "tata-station", brand: "Tata Motors", name: "Our Tata Motors D.E.F. Bulk Dispensing Facility", image: `${IMG}/tata-def-dispensing-station.jpg`,
    features: ["High-Volume Dispensing", "Bulk Storage Tank", "Industrial Grade Setup", "Reliable & Safe Operation"] },
  { id: "tata-machine", brand: "Tata Motors", name: "Our Tata Motors D.E.F. Dispensing Machine", image: `${IMG}/tata-def-dispensing-machine.jpg`,
    features: ["Digital Display (Sale, Litre & Price)", "Automatic Dispensing Nozzle & Hose", "Accurate & Reliable Metering", "Built for Heavy-Duty Use"] },
  { id: "gulf-machine", brand: "Gulf", name: "Our Gulf AdBlue Dispensing Facility", image: `${IMG}/gulf-adblue-dispensing-machine.jpg`,
    features: ["Digital Dispensing Display (Sale, Litre & Price)", "Professional AdBlue Dispensing Nozzle & Hose", "Efficient & Accurate Operation", "Robust & Long-Lasting Build"] },
  { id: "tata-digital", brand: "Tata Motors", name: "Our Advanced Digital D.E.F. Dispensing System", image: `${IMG}/tata-def-digital-dispenser.jpg`,
    features: ["Real-Time Dispensing", "Multi-Parameter Display (Litre, ₹/Litre, Total)", "High Accuracy & Reliability", "Genuine Tata System"] },
];

const Card = ({ e }) => (
  <article data-testid={`equipment-card-${e.id}`} className="group flex h-full flex-col overflow-hidden rounded-[22px] bg-white shadow-[0_30px_60px_-35px_rgba(0,0,0,0.6)] transition-transform duration-500 hover:-translate-y-1">
    <div className="relative overflow-hidden bg-[#EEF3FA]">
      <img src={e.image} alt={e.name} loading="lazy" className="aspect-[1.6/1] w-full object-contain transition-transform duration-[900ms] group-hover:scale-[1.02]" />
      <span className="absolute bottom-0 left-0 h-1 w-0 bg-brand transition-[width] duration-700 group-hover:w-full" />
    </div>
    <div className="flex flex-1 flex-col p-6 sm:p-7">
      <p className="font-mono text-xs uppercase tracking-widest text-brand">{e.brand} · MHM facility</p>
      <h3 className="mt-2 font-display text-2xl sm:text-3xl font-bold uppercase leading-tight text-navy">{e.name}</h3>
      <ul className="mt-4 grid gap-2 sm:grid-cols-2">
        {e.features.map((f) => (
          <li key={f} className="flex gap-2 text-sm text-slate-700"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand" />{f}</li>
        ))}
      </ul>
      <div className="mt-auto flex flex-col gap-2 pt-6 sm:flex-row">
        <a href={waLink(`Hello MHM SUPER ADBLUE, I would like to know more about your ${e.name.replace(/^Our /, "")}.`)} target="_blank" rel="noreferrer" data-testid={`equipment-whatsapp-${e.id}`} className="inline-flex w-full items-center justify-center gap-1.5 rounded-full bg-navy px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#25D366] sm:w-auto">
          <WhatsAppIcon className="h-4 w-4" /> Ask on WhatsApp
        </a>
      </div>
    </div>
  </article>
);

export default function DispensingEquipment() {
  return (
    <section id="dispensing-equipment" data-testid="dispensing-equipment-section" className="relative overflow-hidden bg-gradient-to-b from-navy via-navy to-[#12305a] py-20 md:py-28 text-white">
      <div className="pointer-events-none absolute -right-40 -top-40 h-[28rem] w-[28rem] rounded-full border-[40px] border-brand/15" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="eyebrow text-brand">MHM SUPER ADBLUE infrastructure</p>
          <h2 data-testid="infrastructure-headline" className="mt-4 max-w-4xl font-display text-5xl md:text-6xl font-extrabold uppercase leading-[0.92]">Our machines &amp; dispensing facilities</h2>
          <p data-testid="infrastructure-tagline" className="mt-5 max-w-2xl text-lg text-slate-200">Reliable AdBlue Supply. Modern Dispensing Infrastructure.</p>
          <p className="mt-3 max-w-2xl text-slate-300">Genuine Tata Motors and Gulf AdBlue machines and dispensing equipment used by MHM SUPER ADBLUE to serve our customers.</p>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {EQUIPMENT.map((e, i) => (
            <Reveal key={e.id} delay={(i % 2) * 0.08} className="h-full"><Card e={e} /></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
